import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useMemo } from 'react';
import { Icon } from 'panamera-react-ui';
import cx from 'classnames';
import { FormattedMessage as Translation } from 'react-intl';
import ImageWrapper from "../../../../Components/ImageWrapper/ImageWrapper";
import { SITECODES } from "../../../../Constants/siteCodes";
import { populateStringTemplate } from "../../../../Utils/TextHelper";
import CTA from "../../../../Components/CTA/CTA";
import { useConfig } from "../../../../ComponentDependency/useConfig";
import { EVALUATION_STATES_TRACKING, FLOW_TYPES } from "../../../../Constants/evaluation";
var css = {
  "container": "oalp-2dgE6",
  "carDetails": "oalp-1i_dh",
  "carDetails__mil": "oalp-3tzi8",
  "appointmentDetails": "oalp-1FOVs",
  "widgetTitle": "oalp-1SoVM",
  "rowItem": "oalp-2WIaZ",
  "rowSpace": "oalp-1yEBQ",
  "rowValue": "oalp-1OcNg",
  "daysLeft": "oalp-1FL2n",
  "phone": "oalp-SM4lU",
  "containerTR": "oalp-3KU5c",
  "carDetails__makeModelYear": "oalp-M_BOm",
  "time": "oalp-36mLD"
};
var getDaysLeftComponent = function getDaysLeftComponent(daysLeft) {
  var values = {
    daysLeft: daysLeft
  };
  if (daysLeft == 1) {
    return /*#__PURE__*/React.createElement(Translation, {
      id: "dayLeft",
      values: values
    });
  }
  if (daysLeft > 1) {
    return /*#__PURE__*/React.createElement(Translation, {
      id: "daysLeft",
      values: values
    });
  }
  return null;
};
export var BookingConfirmedL2QMobile = function BookingConfirmedL2QMobile(_ref) {
  var _ref$make = _ref.make,
    make = _ref$make === void 0 ? '' : _ref$make,
    _ref$model = _ref.model,
    model = _ref$model === void 0 ? '' : _ref$model,
    _ref$mileage = _ref.mileage,
    mileage = _ref$mileage === void 0 ? '' : _ref$mileage,
    _ref$mobile = _ref.mobile,
    mobile = _ref$mobile === void 0 ? '' : _ref$mobile,
    _ref$daysLeft = _ref.daysLeft,
    daysLeft = _ref$daysLeft === void 0 ? 0 : _ref$daysLeft,
    _ref$typeOfInspection = _ref.typeOfInspection,
    typeOfInspection = _ref$typeOfInspection === void 0 ? '' : _ref$typeOfInspection,
    _ref$date = _ref.date,
    date = _ref$date === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : _ref$date,
    _ref$time = _ref.time,
    time = _ref$time === void 0 ? '' : _ref$time,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? {} : _ref$title,
    image = _ref.image,
    year = _ref.year,
    name = _ref.name,
    bookingId = _ref.bookingId,
    track = _ref.track,
    onTrack = _ref.onTrack,
    locationId = _ref.locationId,
    cta = _ref.cta;
  var _a;
  var config = useConfig();
  var isTR = useMemo(function () {
    return (config === null || config === void 0 ? void 0 : config.get('siteCode')) === SITECODES.OLXTR;
  }, [config]);
  function buttonJSX() {
    var _a;
    return /*#__PURE__*/React.createElement("div", {
      style: cta === null || cta === void 0 ? void 0 : cta.style
    }, (_a = cta === null || cta === void 0 ? void 0 : cta.buttons) === null || _a === void 0 ? void 0 : _a.map(function (button, idx) {
      button = Object.assign(Object.assign({}, button), {
        invert: false,
        action: populateStringTemplate(button.action, {
          bookingId: bookingId || ''
        })
      });
      return /*#__PURE__*/React.createElement(CTA, {
        "data-aut-id": "see_details_".concat(idx),
        key: "widget_".concat(name),
        button: button,
        customClass: css.manageBookingCTA,
        widgetKey: name || '',
        track: track,
        onTrack: onTrack,
        locationId: locationId,
        select_from: EVALUATION_STATES_TRACKING.BOOKING_CONFIRMATION,
        flow_type: FLOW_TYPES.NO_DRAFT
      });
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx(css.container, _defineProperty({}, css.containerTR, isTR))
  }, /*#__PURE__*/React.createElement("div", {
    className: css.carDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: css.carDetails__makeModelYear
  }, make, " ", model, " ", year), mileage && /*#__PURE__*/React.createElement("div", {
    className: css.carDetails__mil
  }, mileage)), /*#__PURE__*/React.createElement("div", {
    className: css.appointmentDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: css.widgetTitle
  }, title.text), typeOfInspection && /*#__PURE__*/React.createElement("div", {
    className: css.rowItem
  }, image && /*#__PURE__*/React.createElement(ImageWrapper, {
    id: 'ins icon',
    className: css.tagImage,
    image: image
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.rowValue, css.rowSpace)
  }, typeOfInspection)), /*#__PURE__*/React.createElement("div", {
    className: css.rowItem
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "meeting",
    color: "primaryBase",
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.rowSpace)
  }, date)), /*#__PURE__*/React.createElement("div", {
    className: css.rowItem
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "clock",
    color: "primaryBase",
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.rowSpace, css.time)
  }, time)), /*#__PURE__*/React.createElement("div", {
    className: css.rowItem
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "smartphones",
    color: "primaryBase",
    size: 18
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(css.rowSpace, css.phone)
  }, mobile), daysLeft > 0 && /*#__PURE__*/React.createElement("span", {
    className: cx(css.rowValue, css.daysLeft)
  }, getDaysLeftComponent(daysLeft)))), /*#__PURE__*/React.createElement(React.Fragment, null, ((_a = cta === null || cta === void 0 ? void 0 : cta.buttons) === null || _a === void 0 ? void 0 : _a.length) && buttonJSX()));
};
export default BookingConfirmedL2QMobile;